<template>
  <Container>
    <div class="ui segments raised">
      <CardTitle
        title="Farol de Checagens de Equipamentos"
        iconClass="icon lightbulb"
        titleClass="ui green large ribbon label"
      />
      <ContainerBody>
        <div class="ui three stackable centered cards">
          <div class="card" v-for="(item, index) in checagens" :key="index">
            <div class="content">
              <div class="ui grid">
                <div class="column" v-bind:class="item.cor">
                  <div class="center aligned one column">
                    <div class="column" style="padding-bottom:20px; padding-top:20px">
                      {{ item.descricao }}
                    </div>
                  </div>
                  <div class="center aligned one column">
                    <h1 style="font-size: 90px; padding-bottom: 50px">{{ item.equipamentos.length }}</h1>
                  </div>
                  <div class="center aligned one column">
                    <div class="column">
                      <button class="ui basic inverted button fluid" @click="visualiza(item)">MOSTRAR TODOS</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContainerBody>
    </div>
    <ModalEquipamentos
      :title="titleModal"
      :dados="equipamentos"
    />
  </Container>
</template>

<script>

import Container from '@/components/Container.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import CardTitle from '@/components/CardTitle.vue';
import moment from 'moment';
import ModalEquipamentos from '@/components/ModalEquipamentos.vue';

import api from '@/services/api';
import openTab from '@/services/tabs';

export default {
  name: 'FarolEquipamentos',
  components: {
    Container,
    ContainerBody,
    CardTitle,
    ModalEquipamentos,
  },
  data() {
    return {
      checagens: [],
      equipamentos: [],
      titleModal: '',
    };
  },
  created() {
    this.buscaDados();
  },
  methods: {
    async buscaDados() {
      this.$store.commit('global/loading');
      const response = await this.buscaEquipamentos();
      this.checagens = response;
      this.$store.commit('global/loaded');
    },
    async buscaEquipamentos() {
      try {
        const resultEquipamentos = await api.get('/api/servico/farol-equipamentos');
        return resultEquipamentos.data;
      } catch (error) {
        return [];
      }
    },
    showEquipamento(recnum) {
      openTab('scp010a1', 'Equipamento', {
        EXTRECNO: recnum,
        ACAO: 22,
      }, null);
    },
    showOS(oservico) {
      openTab('scp100a1', 'Ordem de Serviço', {
        CODIGO: oservico,
        ACAO: 22,
      }, null);
    },
    FormatarData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    visualiza(item) {
      this.equipamentos = item.equipamentos;
      this.titleModal = `Equipamentos do Conteúdo: ${item.descricao}`;
      this.$store.commit('global/openModal');
    },
  },
};
</script>

<style lang="scss">
  .corpoBank {
    overflow-y: scroll;
  }

  .ui.horizontal.segments > .segment {
    flex: 1 1 !important;
    min-width: 200px;
  }

  .headerFarol {
    overflow-x: hidden;
  }

  .headerFarol .ui.label {
    padding: 3px;
  }

  .headerFarol .ui.segment {
    padding: 5px;
  }

  .headerFarol .ui.header {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .corpoBank .ui.segment, .corpoBank .ui.label {
    padding: 5px;
  }

  .corpoBank .ui.segments:first-child {
    margin-top: 0;
  }

  .corpoBank .ui.segments {
    margin: 5px 0;
  }

  p{
    margin: 0px;
  }

</style>
